module.exports = __webpack_public_path__ + "img/face10.e19994a5.jpg";